// para comprobar si un día está en un rango
export var isInRange = function (rangeFrom, rangeTo, day) {
    var from;
    var to;
    if (rangeFrom) {
        from = new Date();
        from.setFullYear(rangeFrom.year, rangeFrom.month, rangeFrom.day);
        from.setHours(0, 0, 0, 0);
    }
    if (rangeTo) {
        to = new Date();
        to.setFullYear(rangeTo.year, rangeTo.month, rangeTo.day);
        to.setHours(0, 0, 0, 0);
    }
    if (from && from.getFullYear() === day.getFullYear() && from.getMonth() === day.getMonth() && from.getDate() === day.getDate()) {
        return true;
    }
    if (to && to.getFullYear() === day.getFullYear() && to.getMonth() === day.getMonth() && to.getDate() === day.getDate()) {
        return true;
    }
    return day >= from && day <= to;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/CalendarAvailable/Utils.ts
// module id = 271
// module chunks = 0